// === Choisir manuellement l'environnement ===

export const APP_VERSION = "v1.1.15";

// Local
// export let API_URL = "http://localhost:8000";
// export let FRONT_URL = "http://localhost:3000";

// Production HTTP (IP)
// export let API_URL = "http://51.91.103.78:8000";
// export let FRONT_URL = "http://51.91.103.78";


// Production HTTPS (Domaine) - Backend via /api/
export let API_URL = "https://suivezvotrebasculeratp.com/api";
export let FRONT_URL = "https://suivezvotrebasculeratp.com";
